import gql from 'graphql-tag';

export default gql`
mutation setTrackingCJEventCookie($input: TrackingCJEventCookieInput!) {
  setTrackingCJEventCookie(input: $input) {
    successful
  }
}
`;
